import PetDetail from "./PetDetail.tsx";

/** works for either adopted or adoptable pet */
export default function PetDetailWrapper() {
  const searchParams = new URLSearchParams(window.location.search);
  const petId = searchParams.get("pet");
  const adoptionId = searchParams.get("adoption");
  return <PetDetail petId={petId} adoptionId={adoptionId} />;
}
